import { useQuery } from 'wasp/client/operations'
import { getAdminRevenue } from 'wasp/client/operations'
import { AdminRoute } from '../../components/Admin/AdminRoute'
import { Card } from '../../v32/components/ui/card'

export default function AdminRevenuePage() {
  const { data, isLoading, error } = useQuery(getAdminRevenue)
  if (error) return <div className="p-4 text-red-600">Admin revenue unavailable: {String((error as any)?.message || error)}</div>

  const mrr = data?.mrr ?? 0
  const arr = data?.arr ?? 0

  return (
    <AdminRoute>
      <div className="p-4 pb-20 space-y-4">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-semibold">Admin • Revenue</h1>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <Kpi label="MRR (approx.)" value={`${mrr.toFixed(0)}`} />
          <Kpi label="ARR (approx.)" value={`${arr.toFixed(0)}`} />
        </div>

        <Card className="p-4">
          <div className="text-sm text-muted-foreground mb-2">Mix</div>
          <pre className="text-xs overflow-auto">{JSON.stringify(data?.mix, null, 2)}</pre>
        </Card>
      </div>
    </AdminRoute>
  )
}

function Kpi({ label, value }: { label: string; value: string }) {
  return (
    <Card className="p-3">
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className="text-lg font-semibold">{value}</div>
    </Card>
  )
}
